import {
  FETCH_DEVICE_LIST,
  FETCH_DEVICE_LIST_SUCCESS,
  FETCH_DEVICE_LIST_FAILURE,
  RELOAD_DEVICE_LIST,
  RESET_DEVICE_ITEMS,
  SET_DEVICE_PAGE_INDEX,
  SET_DEVICE_PAGE_SIZE,
} from '../../action/Device';

const initialState = {
  isLoading: NaN,
  error: '',
  items: [],
  pageIndex: 0,
  pageSize: 20,
  totalCount: 0,
  requestId: '',
};
const DeviceListReducer = (curState = initialState, action = { type: '', payload: '' }) => {
  let newState;
  switch (action.type) {
    case FETCH_DEVICE_LIST:
      newState = {
        ...curState,
        error: null,
        isLoading: true,
        ...action.payload,
      };
      break;
    case FETCH_DEVICE_LIST_SUCCESS: {
      const {
        resultArr, totalCount, requestId,
      } = action.payload;
      if (requestId === curState.requestId) {
        newState = {
          ...curState,
          totalCount,
          isLoading: false,
          items: curState.items.concat(resultArr),
        };
      } else {
        newState = curState;
      }

      break;
    }
    case FETCH_DEVICE_LIST_FAILURE:
      newState = {
        ...curState, isLoading: false, skip: 0, error: action.payload, requestId: '',
      };
      break;
    case SET_DEVICE_PAGE_SIZE: {
      newState = {
        ...initialState,
        isLoading: curState.isLoading,
        pageSize: action.payload,
      };
      break;
    }
    case SET_DEVICE_PAGE_INDEX: {
      newState = {
        ...curState,
        pageIndex: action.payload,
      };
      break;
    }
    case RESET_DEVICE_ITEMS: {
      newState = { ...initialState };
      break;
    }
    case RELOAD_DEVICE_LIST: {
      const { pageSize } = curState;
      newState = { ...initialState, pageIndex: 0, pageSize };
      break;
    }
    default:
      newState = curState;
  }

  return newState;
};

export default DeviceListReducer;
